var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box",style:({ 'background-position': (_vm.position + " 0") }),attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }